import axiosInstance from "@lib/axios";

export const deleteInstance = async (instance_id: number): Promise<void> => {
    await axiosInstance.post("/instance/delete", { instance_id });
};
